import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Template, Account } from "../core";
import { brdCatchError } from "../shared/message-utils";
import { environment } from "src/environments/environment";
import { DemoTemplateViewModel, TemplateFormViewModel } from "../core/model/ContentManagement";
import { BrdLoggerService } from "@board/cloud-library/components/services";

@Injectable({
  providedIn: "root"
})
export class DemoTemplateService {
  private templateDataSubject = new BehaviorSubject<Template[]>([]);
  templateData$ = this.templateDataSubject.asObservable();

  constructor(
    private readonly httpClient: HttpClient,
    private loggerService: BrdLoggerService
  ) {}

  getAccountsTemplateByName(name: string): Observable<Account[]> {
    return this.httpClient.get<Account[]>(`${environment.API}/DemoInstance/getAccountsTemplate`, { params: { name } });
  }

  controllerName = "Template";
  private apiUrl: string = `${environment.API}/${this.controllerName}`;

  private demoTemplateSubject = new BehaviorSubject<DemoTemplateViewModel[]>([]);
  demoTemplates$ = this.demoTemplateSubject.asObservable();

  getDemoTemplates(): Observable<DemoTemplateViewModel[]> {
    return this.httpClient.get<DemoTemplateViewModel[]>(`${this.apiUrl}/templates`).pipe(
      map(res => {
        this.demoTemplateSubject.next(res);
        return res;
      })
    );
  }

  getActiveTempaltes(): Observable<DemoTemplateViewModel[]> {
    return this.httpClient.get<DemoTemplateViewModel[]>(`${this.apiUrl}/active`).pipe(
      map(res => {
        this.demoTemplateSubject.next(res);
        return res;
      })
    );
  }

  getDemoTemplate(id: number): Observable<DemoTemplateViewModel> {
    return this.httpClient.get<DemoTemplateViewModel>(`${this.apiUrl}/${id}`);
  }

  getTemplateForm(): Observable<TemplateFormViewModel> {
    return this.httpClient.get<TemplateFormViewModel>(`${this.apiUrl}/form`);
  }

  deleteTemplate(id: number): Observable<DemoTemplateViewModel> {
    return this.httpClient.delete<DemoTemplateViewModel>(`${this.apiUrl}/${id}`).pipe(
      map(res => {
        const currentTemplates = [...this.demoTemplateSubject.value];
        const templateIndex = currentTemplates.findIndex(x => x.id === res.id);

        if (templateIndex > -1) {
          currentTemplates.splice(templateIndex, 1);
          this.demoTemplateSubject.next(currentTemplates);
        }

        return res;
      })
    );
  }

  addOrUpdateTemplate(templateModel: DemoTemplateViewModel): Observable<DemoTemplateViewModel> {
    return this.httpClient.post<DemoTemplateViewModel>(`${this.apiUrl}/addOrUpdate`, templateModel).pipe(
      map(res => {
        const currentTemplates = [...this.demoTemplateSubject.value];
        const templateIndex = currentTemplates.findIndex(x => x.id === res.id);
        if (templateIndex > -1) currentTemplates[templateIndex] = res;
        else currentTemplates.push(res);

        this.demoTemplateSubject.next(currentTemplates);
        return res;
      }),
      brdCatchError()
    );
  }
}
